export default {
  pairingStores: [],
  pairingWarehouses: [],
  shipstationInfo: {
    storeCode: '',
    apiKey: '',
    apiSecret: '',
  },
};
